module.exports = __webpack_public_path__ + "img/i_btn_list_p.34f5273e.svg";